var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: !0 });
const REFERRED_TO_BY$1 = "referred_to_by", IDENTIFIED_BY$1 = "identified_by", CARRIED_OUT_BY$1 = "carried_out_by", CLASSIFIED_AS$1 = "classified_as", CARRIES = "carries", CREATED_BY = "created_by", REPRESENTATION$1 = "representation", TOOK_PLACE_AT = "took_place_at", PRODUCED_BY$1 = "produced_by", TIMESPAN$1 = "timespan", COORDS = "crm:E47_Spatial_Coordinates", PART_OF = "part_of", DIGITALLY_SHOWN_BY = "digitally_shown_by";
var __defProp2 = Object.defineProperty, __name2 = /* @__PURE__ */ __name((target, value) => __defProp2(target, "name", { value, configurable: !0 }), "__name");
const LANGUAGES = { en: "http://vocab.getty.edu/aat/300388277", fr: "http://vocab.getty.edu/aat/300388306", de: "http://vocab.getty.edu/aat/300388344", es: "http://vocab.getty.edu/aat/300389311", zh: "http://vocab.getty.edu/aat/300388113", hi: "http://vocab.getty.edu/aat/300388412", af: "http://vocab.getty.edu/aat/300387782", sq: "http://vocab.getty.edu/aat/300387803", ar: "http://vocab.getty.edu/aat/300387843", bg: "http://vocab.getty.edu/aat/300388034", bs: "http://vocab.getty.edu/aat/300388023", ca: "http://vocab.getty.edu/aat/300388072", pt: "http://vocab.getty.edu/aat/300389115", bn: "http://vocab.getty.edu/aat/300387971", ru: "http://vocab.getty.edu/aat/300389168", nl: "http://vocab.getty.edu/aat/300388256", fi: "http://vocab.getty.edu/aat/300388299", is: "http://vocab.getty.edu/aat/300388449", ga: "http://vocab.getty.edu/aat/300388467", it: "http://vocab.getty.edu/aat/300388474", fa: "http://vocab.getty.edu/aat/300388296", gu: "http://vocab.getty.edu/aat/300388371", ko: "http://vocab.getty.edu/aat/300388633", la: "http://vocab.getty.edu/aat/300388693", lt: "http://vocab.getty.edu/aat/300388723", mk: "http://vocab.getty.edu/aat/300388760", ja: "http://vocab.getty.edu/aat/300388486", hr: "http://vocab.getty.edu/aat/300388185", cs: "http://vocab.getty.edu/aat/300388191", da: "http://vocab.getty.edu/aat/300388204", el: "http://vocab.getty.edu/aat/300388361", ka: "http://vocab.getty.edu/aat/300388343", he: "http://vocab.getty.edu/aat/300388401", hu: "http://vocab.getty.edu/aat/300388770", no: "http://vocab.getty.edu/aat/300388992", pl: "http://vocab.getty.edu/aat/300389109", ro: "http://vocab.getty.edu/aat/300389157", sk: "http://vocab.getty.edu/aat/300389290", sl: "http://vocab.getty.edu/aat/300389291", sr: "http://vocab.getty.edu/aat/300389247", sv: "http://vocab.getty.edu/aat/300389336", tr: "http://vocab.getty.edu/aat/300389470", cy: "http://vocab.getty.edu/aat/300389555" }, ACCESSION_NUMBERS = "http://vocab.getty.edu/aat/300312355", ACKNOWLEDGEMENT = "http://vocab.getty.edu/aat/300026687", COPYRIGHT$1 = "http://vocab.getty.edu/aat/300435434", CULTURE$1 = "http://vocab.getty.edu/aat/300055768", DIGITAL_IMAGES = "http://vocab.getty.edu/aat/300215302", DIMENSIONS_DESCRIPTION$1 = "http://vocab.getty.edu/aat/300435430", LEGAL_CONCEPTS = "http://vocab.getty.edu/aat/300055547", MATERIALS_DESCRIPTION$1 = "http://vocab.getty.edu/aat/300435429", PREFERRED_TERM$1 = "http://vocab.getty.edu/aat/300404670", RIGHTS = "http://vocab.getty.edu/aat/300417696", WORK_TYPE = "http://vocab.getty.edu/aat/300435443", CLASSIFICATION$1 = "http://vocab.getty.edu/aat/300435444", aat$2 = {
  LANGUAGES,
  ACCESSION_NUMBERS,
  ACKNOWLEDGEMENT,
  COPYRIGHT: COPYRIGHT$1,
  CULTURE: CULTURE$1,
  DIGITAL_IMAGES,
  DIMENSIONS_DESCRIPTION: DIMENSIONS_DESCRIPTION$1,
  LEGAL_CONCEPTS,
  MATERIALS_DESCRIPTION: MATERIALS_DESCRIPTION$1,
  PREFERRED_TERM: PREFERRED_TERM$1,
  RIGHTS,
  WORK_TYPE,
  CLASSIFICATION: CLASSIFICATION$1
}, AND = "AND", ASSIGNED = "assigned", ASSIGNED_BY = "assigned_by", ASSIGNED_PROPERTY = "assigned_property", ATTRIBUTED_BY = "attributed_by", CARRIED_OUT_BY = "carried_out_by", CLASSIFIED_AS = "classified_as", CLASSIFIED_BY = "classified_by", IDENTIFIED_BY = "identified_by", NAME$1 = "Name", OR = "OR", PART = "part", PRODUCED_BY = "produced_by", REFERRED_TO_BY = "referred_to_by", REPRESENTATION = "representation", SUBJECT_TO = "subject_to", TIMESPAN = "timespan", UNKNOWN = "Unknown";
function normalizeFieldToArray(obj, key) {
  if (obj == null)
    return [];
  var val = obj[key];
  return val == null ? [] : Array.isArray(val) == !1 ? [val] : val.length < 1 ? [] : val;
}
__name(normalizeFieldToArray, "normalizeFieldToArray");
__name2(normalizeFieldToArray, "normalizeFieldToArray");
function normalizeAatId(id) {
  let id_ = id.toLowerCase();
  return id_.startsWith("aat:") ? id_.replace("aat:", "http://vocab.getty.edu/aat/") : id_.startsWith("https://vocab.getty.edu/aat/") ? id_.replace(
    "https://vocab.getty.edu/aat/",
    "http://vocab.getty.edu/aat/"
  ) : id_.replace("http://vocab.getty.edu/aat/", "aat:");
}
__name(normalizeAatId, "normalizeAatId");
__name2(normalizeAatId, "normalizeAatId");
function normalizeFieldWithParts(object, field) {
  let part = object[field];
  if (part == null)
    return [];
  let parts = [];
  return Array.isArray(part[PART]) == !1 ? Array.isArray(part) ? parts = part : parts = [part] : (parts = [...part[PART]], _hasUniqueFields(part, ["id", "_label", "label", "type", PART]) && parts.push(part)), parts;
}
__name(normalizeFieldWithParts, "normalizeFieldWithParts");
__name2(normalizeFieldWithParts, "normalizeFieldWithParts");
function _hasUniqueFields(object, fieldsToIgnore = ["id", "_label", "label", "type"]) {
  let keys = Object.keys(object);
  return keys.filter((key) => fieldsToIgnore.indexOf(key) == !1), keys.length > 0;
}
__name(_hasUniqueFields, "_hasUniqueFields");
__name2(_hasUniqueFields, "_hasUniqueFields");
const NO_LANGUAGE = "NO_LANGUAGE";
function doesObjectLanguageMatch(object, language, languageOptions = {}) {
  if (language == null)
    return !0;
  let lang_ids = getLanguageId(object, languageOptions);
  return lang_ids.includes(normalizeLanguageId(language, languageOptions)) || languageOptions.fallbackLanguage != null && lang_ids.includes(
    normalizeLanguageId(languageOptions.fallbackLanguage, languageOptions)
  ) ? !0 : lang_ids.includes(NO_LANGUAGE) || lang_ids.length == 0 ? languageOptions.includeItemsWithNoLanguage != !1 : !1;
}
__name(doesObjectLanguageMatch, "doesObjectLanguageMatch");
__name2(doesObjectLanguageMatch, "doesObjectLanguageMatch");
function getLanguageId(obj, languageOptions) {
  if (obj == null || obj.language == null)
    return [NO_LANGUAGE];
  if (typeof obj.language == "string")
    return [normalizeLanguageId(obj.language, languageOptions)];
  let toReturn = /* @__PURE__ */ new Set();
  return obj.language.forEach((lang) => {
    lang == null ? toReturn.add(NO_LANGUAGE) : typeof lang == "string" ? toReturn.add(lang) : lang.id && toReturn.add(lang.id);
  }), toReturn = Array.from(toReturn).map(
    (item) => normalizeLanguageId(item, languageOptions)
  ), toReturn;
}
__name(getLanguageId, "getLanguageId");
__name2(getLanguageId, "getLanguageId");
function normalizeLanguageId(lang_id, languageOptions) {
  if (lang_id == null)
    return NO_LANGUAGE;
  let lookupMap = aat$2.LANGUAGES;
  languageOptions && languageOptions.lookupMap && (lookupMap = languageOptions.lookupMap);
  let lang = lang_id.toLowerCase();
  return lang.match(/\/[a-zA-Z]+$/) && (lang = lang.substring(lang.lastIndexOf("/") + 1)), lookupMap[lang] ?? lang_id;
}
__name(normalizeLanguageId, "normalizeLanguageId");
__name2(normalizeLanguageId, "normalizeLanguageId");
function lookupIsoFromAat(id = "") {
  let iso, normalizedAat = id;
  return (id.startsWith("aat:") || id.startsWith("https")) && (normalizedAat = normalizeAatId(id)), Object.keys(aat$2.LANGUAGES).forEach((key) => {
    aat$2.LANGUAGES[key] == normalizedAat && (iso = key);
  }), iso;
}
__name(lookupIsoFromAat, "lookupIsoFromAat");
__name2(lookupIsoFromAat, "lookupIsoFromAat");
function lookupAatFromIso(iso) {
  return aat$2.LANGUAGES[iso];
}
__name(lookupAatFromIso, "lookupAatFromIso");
__name2(lookupAatFromIso, "lookupAatFromIso");
function getClassifiedAs(submittedResource, requestedClassifications, { language = void 0, languageOptions = {}, operator } = {}) {
  return getClassified(submittedResource, requestedClassifications, {
    classificationField: CLASSIFIED_AS,
    language,
    languageOptions,
    operator
  });
}
__name(getClassifiedAs, "getClassifiedAs");
__name2(getClassifiedAs, "getClassifiedAs");
function getClassifiedBy(submittedResource, requestedClassifications, { language = void 0, languageOptions = {}, operator } = {}) {
  return getClassified(submittedResource, requestedClassifications, {
    classificationField: CLASSIFIED_BY,
    language,
    languageOptions,
    operator
  });
}
__name(getClassifiedBy, "getClassifiedBy");
__name2(getClassifiedBy, "getClassifiedBy");
function getClassifiedAsWithClassification(submittedResource, nestedClassification, { language = void 0, languageOptions = {}, operator } = {}) {
  return _getClassificationsWithNestedClass(
    submittedResource,
    nestedClassification,
    CLASSIFIED_AS,
    { language, languageOptions, operator }
  );
}
__name(getClassifiedAsWithClassification, "getClassifiedAsWithClassification");
__name2(getClassifiedAsWithClassification, "getClassifiedAsWithClassification");
function getClassifiedByWithClassification(submittedResource, nestedClassification, { language = void 0, languageOptions = {}, operator } = {}) {
  return _getClassificationsWithNestedClass(
    submittedResource,
    nestedClassification,
    CLASSIFIED_BY,
    { language, languageOptions, operator }
  );
}
__name(getClassifiedByWithClassification, "getClassifiedByWithClassification");
__name2(getClassifiedByWithClassification, "getClassifiedByWithClassification");
function getObjectsClassifiedAsWithClassification(submittedResource, nestedClassification, { language = void 0, languageOptions = {}, operator } = {}) {
  return _getObjectWithNestedClass(
    submittedResource,
    nestedClassification,
    CLASSIFIED_AS,
    { language, languageOptions, operator }
  );
}
__name(getObjectsClassifiedAsWithClassification, "getObjectsClassifiedAsWithClassification");
__name2(getObjectsClassifiedAsWithClassification, "getObjectsClassifiedAsWithClassification");
function getObjectsClassifiedByWithClassification(submittedResource, nestedClassification, { language = void 0, languageOptions = {} } = {}) {
  return _getObjectWithNestedClass(
    submittedResource,
    nestedClassification,
    CLASSIFIED_BY,
    { language, languageOptions }
  );
}
__name(getObjectsClassifiedByWithClassification, "getObjectsClassifiedByWithClassification");
__name2(getObjectsClassifiedByWithClassification, "getObjectsClassifiedByWithClassification");
function getPrimaryName(submittedResource, {
  requestedClassifications = aat$2.PREFERRED_TERM,
  language,
  languageOptions = {}
} = {}) {
  return getPrimaryNames(submittedResource, {
    requestedClassifications,
    language,
    languageOptions
  })[0];
}
__name(getPrimaryName, "getPrimaryName");
__name2(getPrimaryName, "getPrimaryName");
function getPrimaryNames(submittedResource, {
  requestedClassifications = aat$2.PREFERRED_TERM,
  language,
  languageOptions = {}
} = {}) {
  if (submittedResource == null)
    return UNKNOWN;
  let names = normalizeFieldToArray(submittedResource, IDENTIFIED_BY).filter((item) => item.type == NAME$1), name = getValuesByClassification(names, requestedClassifications, {
    language,
    languageOptions
  });
  if (name.length > 0)
    return name;
  if (names.length > 0 && requestedClassifications == aat$2.PREFERRED_TERM) {
    let values = [...names];
    for (let i in values)
      values[i] = getValueOrContent(values[i]);
    return values;
  }
  let label = UNKNOWN;
  return submittedResource && submittedResource.id && (label += " (" + submittedResource.id + ")"), [label];
}
__name(getPrimaryNames, "getPrimaryNames");
__name2(getPrimaryNames, "getPrimaryNames");
function getClassified(submittedResource, requestedClassifications, {
  classificationField = CLASSIFIED_AS,
  language = void 0,
  languageOptions = {},
  operator = AND
} = {}) {
  let results = [], resourceArray = _convertToArrayIfNeeded(submittedResource), requestedClassArray = _convertToArrayIfNeeded(requestedClassifications);
  if (resourceArray.length == 0 || requestedClassArray.length == 0)
    return results;
  for (const resource of resourceArray) {
    var classified_as = normalizeFieldToArray(resource, classificationField);
    let languageMatch = doesObjectLanguageMatch(
      resource,
      language,
      languageOptions
    );
    if (!classified_as.length)
      continue;
    let classificationIDs = classified_as.map(
      (obj) => typeof obj == "string" ? obj : obj.id
    ), inClassificationIDs = /* @__PURE__ */ __name2((id) => languageMatch && classificationIDs.includes(id) || classificationIDs.includes(normalizeAatId(id)), "inClassificationIDs");
    if (operator.toUpperCase() == AND)
      requestedClassArray.every(inClassificationIDs) && results.push(resource);
    else if (operator.toUpperCase() == OR)
      requestedClassArray.some(inClassificationIDs) && results.push(resource);
    else
      throw `unknown operator specified: ${operator}, please use and/or`;
  }
  return results;
}
__name(getClassified, "getClassified");
__name2(getClassified, "getClassified");
function getValueByClassification(submittedResource, requestedClassifications, { language, languageOptions, operator } = {}) {
  let results = getClassifiedAs(submittedResource, requestedClassifications, {
    language,
    languageOptions,
    operator
  });
  if (results.length)
    return getValueOrContent(results[0]);
}
__name(getValueByClassification, "getValueByClassification");
__name2(getValueByClassification, "getValueByClassification");
function getValuesByClassification(submittedResource, requestedClassifications, { language, languageOptions, operator } = {}) {
  let results = getClassifiedAs(submittedResource, requestedClassifications, {
    language,
    languageOptions,
    operator
  });
  if (results.length) {
    let values = [];
    return results.forEach((result) => {
      const value = getValueOrContent(result);
      value && values.push(value);
    }), values;
  }
  return [];
}
__name(getValuesByClassification, "getValuesByClassification");
__name2(getValuesByClassification, "getValuesByClassification");
function getValueOrContent(object) {
  if (object != null) {
    if (object.value !== void 0)
      return object.value;
    if (object.content)
      return object.content;
  }
}
__name(getValueOrContent, "getValueOrContent");
__name2(getValueOrContent, "getValueOrContent");
function getReferredToByClassification$1(object, classification) {
  if (!object) return;
  const referredToBy = object[REFERRED_TO_BY];
  if (referredToBy)
    return getValueByClassification(referredToBy, classification);
}
__name(getReferredToByClassification$1, "getReferredToByClassification$1");
__name2(getReferredToByClassification$1, "getReferredToByClassification");
function getAttributedBy(object, assignedProperty) {
  let attributed = normalizeFieldToArray(object, ATTRIBUTED_BY);
  return attributed.length == 0 ? [] : _getAssignedProperty(attributed, assignedProperty);
}
__name(getAttributedBy, "getAttributedBy");
__name2(getAttributedBy, "getAttributedBy");
function getAssignedBy(object, assignedProperty) {
  let assigned = normalizeFieldToArray(object, ASSIGNED_BY);
  return assigned.length == 0 ? [] : _getAssignedProperty(assigned, assignedProperty);
}
__name(getAssignedBy, "getAssignedBy");
__name2(getAssignedBy, "getAssignedBy");
function getObjectParts(object, field) {
  const fieldRequested = object[field];
  if (!fieldRequested)
    return [];
  let fieldPart = normalizeFieldToArray(fieldRequested, PART);
  return fieldPart.length == 0 ? [fieldRequested] : fieldPart;
}
__name(getObjectParts, "getObjectParts");
__name2(getObjectParts, "getObjectParts");
function _convertToArrayIfNeeded(resourceParam) {
  let results = [], resourceArray = resourceParam;
  return resourceParam == null ? results : (Array.isArray(resourceParam) == !1 && (resourceArray = [resourceParam]), resourceArray);
}
__name(_convertToArrayIfNeeded, "_convertToArrayIfNeeded");
__name2(_convertToArrayIfNeeded, "_convertToArrayIfNeeded");
function _getAssignedProperty(assigned, assignedProperty) {
  let accumulator = [];
  return assigned.forEach((attr) => {
    (attr[ASSIGNED_PROPERTY] == assignedProperty || assignedProperty == null) && (Array.isArray(attr[ASSIGNED]) ? accumulator = accumulator.concat(attr[ASSIGNED]) : accumulator.push(attr[ASSIGNED]));
  }), accumulator;
}
__name(_getAssignedProperty, "_getAssignedProperty");
__name2(_getAssignedProperty, "_getAssignedProperty");
function _getObjectWithNestedClass(submittedResource, nestedClassification, classificationField = CLASSIFIED_AS, { language = void 0, languageOptions = {}, operator } = {}) {
  let { objects } = _getObjectsAndClassificationsWithNestedClass(
    submittedResource,
    nestedClassification,
    classificationField,
    { language, languageOptions, operator }
  );
  return objects;
}
__name(_getObjectWithNestedClass, "_getObjectWithNestedClass");
__name2(_getObjectWithNestedClass, "_getObjectWithNestedClass");
function _getClassificationsWithNestedClass(submittedResource, nestedClassifications, classificationField = CLASSIFIED_AS, { language = void 0, languageOptions = {}, operator } = {}) {
  let { classifications } = _getObjectsAndClassificationsWithNestedClass(
    submittedResource,
    nestedClassifications,
    classificationField,
    { language, languageOptions, operator }
  );
  return classifications;
}
__name(_getClassificationsWithNestedClass, "_getClassificationsWithNestedClass");
__name2(_getClassificationsWithNestedClass, "_getClassificationsWithNestedClass");
function _getObjectsAndClassificationsWithNestedClass(submittedResource, nestedClassifications, classificationField = CLASSIFIED_AS, { language = void 0, languageOptions = {}, operator }) {
  let returnObject = { classifications: [], objects: [] }, resourceArray = _convertToArrayIfNeeded(submittedResource);
  if (resourceArray.length == 0)
    return returnObject;
  for (const resource of resourceArray) {
    var classified_as = normalizeFieldToArray(resource, classificationField);
    if (!classified_as.length)
      continue;
    let classifications = getClassified(classified_as, nestedClassifications, {
      classificationField,
      language,
      languageOptions,
      operator
    });
    returnObject.classifications = returnObject.classifications.concat(classifications), classifications.length > 0 && returnObject.objects.push(resource);
  }
  return returnObject;
}
__name(_getObjectsAndClassificationsWithNestedClass, "_getObjectsAndClassificationsWithNestedClass");
__name2(_getObjectsAndClassificationsWithNestedClass, "_getObjectsAndClassificationsWithNestedClass");
function getFieldPartSubfield(object, field, subfield) {
  let parts = normalizeFieldWithParts(object, field), accumulator = [];
  return parts.forEach((part) => {
    let target = normalizeFieldToArray(part, subfield);
    accumulator = accumulator.concat(target);
  }), accumulator;
}
__name(getFieldPartSubfield, "getFieldPartSubfield");
__name2(getFieldPartSubfield, "getFieldPartSubfield");
function getFieldValuesByClassifications(submittedResource, field, requestedClassifications, { language, languageOptions, operator } = {}) {
  return getValuesByClassification(
    normalizeFieldToArray(submittedResource, field),
    requestedClassifications,
    { language, languageOptions, operator }
  );
}
__name(getFieldValuesByClassifications, "getFieldValuesByClassifications");
__name2(getFieldValuesByClassifications, "getFieldValuesByClassifications");
function getDimensionsDescriptions(submittedResource, {
  requestedClassifications = aat$2.DIMENSIONS_DESCRIPTION,
  language,
  languageOptions = {}
} = {}) {
  return getFieldValuesByClassifications(
    submittedResource,
    REFERRED_TO_BY,
    requestedClassifications,
    { language, languageOptions }
  );
}
__name(getDimensionsDescriptions, "getDimensionsDescriptions");
__name2(getDimensionsDescriptions, "getDimensionsDescriptions");
function getAccessionNumbers(submittedResource, {
  requestedClassifications = aat$2.ACCESSION_NUMBERS,
  language,
  languageOptions = {}
} = {}) {
  return getFieldValuesByClassifications(
    submittedResource,
    IDENTIFIED_BY,
    requestedClassifications,
    { language, languageOptions }
  );
}
__name(getAccessionNumbers, "getAccessionNumbers");
__name2(getAccessionNumbers, "getAccessionNumbers");
function getCarriedOutBy(object, field = PRODUCED_BY) {
  return getFieldPartSubfield(object, field, CARRIED_OUT_BY);
}
__name(getCarriedOutBy, "getCarriedOutBy");
__name2(getCarriedOutBy, "getCarriedOutBy");
function getCultures(submittedResource, {
  requestedClassifications = aat$2.CULTURE,
  language,
  languageOptions = {}
} = {}) {
  return getFieldValuesByClassifications(
    submittedResource,
    REFERRED_TO_BY,
    requestedClassifications,
    { language, languageOptions }
  );
}
__name(getCultures, "getCultures");
__name2(getCultures, "getCultures");
function getDigitalImages(submittedResource, { requestedClassifications = aat$2.DIGITAL_IMAGES } = {}) {
  const representations = normalizeFieldToArray(
    submittedResource,
    REPRESENTATION
  );
  return getClassifiedAs(
    representations,
    requestedClassifications
  ).map((img) => img.id);
}
__name(getDigitalImages, "getDigitalImages");
__name2(getDigitalImages, "getDigitalImages");
function getRightsStatements(submittedResource, {
  requestedClassifications = [aat$2.LEGAL_CONCEPTS, aat$2.RIGHTS],
  language,
  languageOptions = {}
} = {}) {
  const referredToBy = normalizeFieldToArray(submittedResource, REFERRED_TO_BY);
  return getClassified(referredToBy, requestedClassifications, {
    classificationField: CLASSIFIED_AS,
    language,
    languageOptions,
    operator: OR
  }).map((right) => getValueOrContent(right));
}
__name(getRightsStatements, "getRightsStatements");
__name2(getRightsStatements, "getRightsStatements");
function getCopyrightStatements(submittedResource, {
  requestedClassifications = aat$2.COPYRIGHT,
  language,
  languageOptions = {}
} = {}) {
  return getFieldValuesByClassifications(
    submittedResource,
    REFERRED_TO_BY,
    requestedClassifications,
    { language, languageOptions }
  );
}
__name(getCopyrightStatements, "getCopyrightStatements");
__name2(getCopyrightStatements, "getCopyrightStatements");
function getRightsAssertions(submittedResource) {
  const subjectTo = normalizeFieldToArray(submittedResource, SUBJECT_TO);
  let rightsAssertions = [];
  return subjectTo.forEach((obj) => {
    rightsAssertions = rightsAssertions.concat(obj[CLASSIFIED_AS]);
  }), rightsAssertions.map((d) => d.id);
}
__name(getRightsAssertions, "getRightsAssertions");
__name2(getRightsAssertions, "getRightsAssertions");
function getAcknowledgementStatements(submittedResource, {
  requestedClassifications = aat$2.ACKNOWLEDGEMENT,
  language,
  languageOptions = {}
} = {}) {
  return getFieldValuesByClassifications(
    submittedResource,
    REFERRED_TO_BY,
    requestedClassifications,
    { language, languageOptions }
  );
}
__name(getAcknowledgementStatements, "getAcknowledgementStatements");
__name2(getAcknowledgementStatements, "getAcknowledgementStatements");
function getMaterialStatements(submittedResource, {
  requestedClassifications = aat$2.MATERIALS_DESCRIPTION,
  language,
  languageOptions = {}
} = {}) {
  return getFieldValuesByClassifications(
    submittedResource,
    REFERRED_TO_BY,
    requestedClassifications,
    { language, languageOptions }
  );
}
__name(getMaterialStatements, "getMaterialStatements");
__name2(getMaterialStatements, "getMaterialStatements");
function getProductionTimespans(object) {
  return getFieldPartSubfield(object, PRODUCED_BY, TIMESPAN);
}
__name(getProductionTimespans, "getProductionTimespans");
__name2(getProductionTimespans, "getProductionTimespans");
function getWorkTypes(submittedResource, {
  requestedClassifications = aat$2.WORK_TYPE,
  language,
  languageOptions = {}
} = {}) {
  return getClassifiedAsWithClassification(
    submittedResource,
    requestedClassifications,
    { language, languageOptions }
  );
}
__name(getWorkTypes, "getWorkTypes");
__name2(getWorkTypes, "getWorkTypes");
function getClassifications(submittedResource, {
  requestedClassifications = aat$2.CLASSIFICATION,
  language,
  languageOptions = {}
} = {}) {
  return getClassifiedAsWithClassification(
    submittedResource,
    requestedClassifications,
    { language, languageOptions }
  );
}
__name(getClassifications, "getClassifications");
__name2(getClassifications, "getClassifications");
function getAllIds(object, value_prefix, accumulator_) {
  let accumulator = accumulator_;
  return accumulator == null && (accumulator = /* @__PURE__ */ new Set()), object == null || (Array.isArray(object) === !0 ? object.forEach((item) => {
    getAllIds(item, value_prefix, accumulator);
  }) : object === Object(object) && (object.id && object.id.indexOf(value_prefix) != -1 && accumulator.add(object.id), Object.keys(object).forEach((key) => {
    getAllIds(object[key], value_prefix, accumulator);
  }))), accumulator;
}
__name(getAllIds, "getAllIds");
function getMostReferenced(references) {
  let counts = references.map(
    (resource) => resource[REFERRED_TO_BY$1] ? resource[REFERRED_TO_BY$1].length : 0
  ), most = Math.max.apply(null, counts);
  return most === 0 ? references[0].content : references.find(
    (resource) => resource[REFERRED_TO_BY$1] && resource[REFERRED_TO_BY$1].length === most
  ).content;
}
__name(getMostReferenced, "getMostReferenced");
function getContentWithFormat(object, subField = REFERRED_TO_BY$1, classifiedAs = aat.DESCRIPTION, format = void 0) {
  const descriptions = getClassifiedAs(
    normalizeFieldToArray(object, subField),
    classifiedAs
  );
  let matches = [];
  for (let description of descriptions)
    (format == null || format == description.format) && matches.push(getValueOrContent(description));
  return matches;
}
__name(getContentWithFormat, "getContentWithFormat");
const ACCESSION_NUMBER = "http://vocab.getty.edu/aat/300312355", ACTIVE = "http://vocab.getty.edu/aat/300393177", AIN = "http://vocab.getty.edu/aat/300435221", ALTERNATE_DESCRIPTOR = "http://vocab.getty.edu/term/type/AlternateDescriptor", ALTERNATE_TITLE = "http://vocab.getty.edu/aat/300417227", BIOGRAPHIES = "http://vocab.getty.edu/aat/300080102", CLASSIFICATION = "http://vocab.getty.edu/aat/300435444", COPYRIGHT = "http://vocab.getty.edu/aat/300435434", CULTURE = "http://vocab.getty.edu/aat/300055768", DESCRIPTION = "http://vocab.getty.edu/aat/300080091", DESCRIPTIVE_NOTE = "http://vocab.getty.edu/aat/300435416", DESCRIPTOR_URI = "http://vocab.getty.edu/term/type/Descriptor", DIGITAL_IMAGE = "http://vocab.getty.edu/aat/300215302", DIMENSIONS_DESCRIPTION = "http://vocab.getty.edu/aat/300435430", DISTANCE_UNIT = "http://vocab.getty.edu/aat/300379251", IDENTIFICATION_NUMBER = "http://vocab.getty.edu/aat/300404626", INSCRIPTIONS = "http://vocab.getty.edu/aat/300435414", MARKS = "http://vocab.getty.edu/aat/300435420", MATERIALS_DESCRIPTION = "http://vocab.getty.edu/aat/300435429", NAME = "http://vocab.getty.edu/aat/300404650", NATIONALITY = "http://vocab.getty.edu/aat/300379842", OBJECT_TYPE = "http://vocab.getty.edu/aat/300435443", PLACE_CREATED = "http://vocab.getty.edu/aat/300435448", PLACE_PREFERRED_TERM = "http://vocab.getty.edu/aat/300404650", PLURAL_NOUN = "http://vocab.getty.edu/term/POS/PluralNoun", PREFERRED_TERM = "http://vocab.getty.edu/aat/300404670", RIGHTS_STATEMENT = "http://vocab.getty.edu/aat/300417696", ROLES = "http://vocab.getty.edu/aat/300435108", SIGNATURES_DESCRIPTION = "http://vocab.getty.edu/aat/300028705", SINGULAR_AND_PLURAL = "http://vocab.getty.edu/term/POS/BothSingularAndPlural", SINGULAR_NOUN = "http://vocab.getty.edu/term/POS/SingularNoun", STREET_ADDRESSES = "http://vocab.getty.edu/aat/300386983", WATERMARKS = "http://vocab.getty.edu/aat/300435421", aat$1 = {
  ACCESSION_NUMBER,
  ACTIVE,
  AIN,
  ALTERNATE_DESCRIPTOR,
  ALTERNATE_TITLE,
  BIOGRAPHIES,
  CLASSIFICATION,
  COPYRIGHT,
  CULTURE,
  DESCRIPTION,
  DESCRIPTIVE_NOTE,
  DESCRIPTOR_URI,
  DIGITAL_IMAGE,
  DIMENSIONS_DESCRIPTION,
  DISTANCE_UNIT,
  IDENTIFICATION_NUMBER,
  INSCRIPTIONS,
  MARKS,
  MATERIALS_DESCRIPTION,
  NAME,
  NATIONALITY,
  OBJECT_TYPE,
  PLACE_CREATED,
  PLACE_PREFERRED_TERM,
  PLURAL_NOUN,
  PREFERRED_TERM,
  RIGHTS_STATEMENT,
  ROLES,
  SIGNATURES_DESCRIPTION,
  SINGULAR_AND_PLURAL,
  SINGULAR_NOUN,
  STREET_ADDRESSES,
  WATERMARKS
}, DEFAULT_LANGS = ["en-us", "en"], defaultNameExcludes = ["http://vocab.getty.edu/historic/localUse"], SINGULAR = [
  [aat$1.DESCRIPTOR_URI, aat$1.SINGULAR_NOUN],
  [aat$1.DESCRIPTOR_URI, aat$1.SINGULAR_AND_PLURAL],
  [aat$1.ALTERNATE_DESCRIPTOR, aat$1.SINGULAR_NOUN],
  [aat$1.ALTERNATE_DESCRIPTOR, aat$1.SINGULAR_AND_PLURAL],
  [aat$1.DESCRIPTOR_URI]
], PLURAL = [
  [aat$1.DESCRIPTOR_URI, aat$1.PLURAL_NOUN],
  [aat$1.DESCRIPTOR_URI, aat$1.SINGULAR_AND_PLURAL],
  [aat$1.ALTERNATE_DESCRIPTOR, aat$1.PLURAL_NOUN],
  [aat$1.ALTERNATE_DESCRIPTOR, aat$1.SINGULAR_AND_PLURAL],
  [aat$1.DESCRIPTOR_URI]
];
function findAndGetAATValue(obj) {
  return findAndGetValue(obj, getAATValue);
}
__name(findAndGetAATValue, "findAndGetAATValue");
function findAndGetULANValue(obj) {
  return findAndGetValue(obj, getULANValue);
}
__name(findAndGetULANValue, "findAndGetULANValue");
function findAndGetTGNValue(obj) {
  return findAndGetValue(obj, getTGNValue);
}
__name(findAndGetTGNValue, "findAndGetTGNValue");
function findAndGetValue(obj, callback) {
  let toReturn;
  if (obj.id == null || obj.qualifiers == null)
    return;
  obj.id.endsWith("/") && (obj.id = obj.id.slice(0, -1));
  let term = findVocabObject(obj.id, obj.qualifiers);
  return term != null && (toReturn = callback(term, obj)), toReturn;
}
__name(findAndGetValue, "findAndGetValue");
function findVocabObject(objectID, vocabArray) {
  let toReturn, objNumID = objectID.split("/").slice(-1)[0];
  return vocabArray.forEach((term) => {
    let termID = term.id.split("/").slice(-1)[0];
    term != null && termID == objNumID && (toReturn = term);
  }), toReturn;
}
__name(findVocabObject, "findVocabObject");
function getNamesByLang(term, excludeClassifications = []) {
  let all_names = getClassifiedAs(term.identified_by, aat$1.NAME);
  all_names = all_names.filter(
    (name) => getClassifiedAs(name, excludeClassifications).length == 0
  );
  let no_lang = [], names = {};
  return all_names.forEach((n) => {
    let val = getValue(n, !0);
    if (n.language) {
      let langs = getLanguages(n);
      typeof langs == "string" && (langs = [langs]);
      for (var lang of langs)
        names[lang] ? names[lang].push(val) : names[lang] = [val];
    } else
      no_lang.push(getValue(n, !0));
  }), names.no_lang = no_lang, names;
}
__name(getNamesByLang, "getNamesByLang");
function getPreferredName(term) {
  let preferredName = {}, name = getClassifiedAs(term.identified_by, aat$1.PREFERRED_TERM).length ? getClassifiedAs(term.identified_by, aat$1.PREFERRED_TERM)[0] : void 0;
  return name != null && name.language ? preferredName[getLanguages(name)] = getValue(name, !0) : name && (preferredName.no_lang = getValue(name, !0)), preferredName;
}
__name(getPreferredName, "getPreferredName");
function getPartByType(termPart, qualifier, _langs) {
  let toReturn = [];
  return Array.isArray(termPart) == !1 || termPart.forEach((part) => {
    if (part.type == qualifier) {
      let val = getValue(part, !0);
      toReturn.push(val);
    }
  }), toReturn;
}
__name(getPartByType, "getPartByType");
function getULANValue(term, object = {}) {
  const obj = {};
  obj.lang = object.lang == null ? "en" : object.lang, obj.born = term.born, obj.died = term.died;
  let nameExclude = defaultNameExcludes;
  "nameExclude" in object && (nameExclude = object.nameExclude), obj.subject_of = getPartByType(
    term.subject_of,
    "LinguisticObject",
    object.langs
  ), obj.names = getNamesByLang(term, nameExclude);
  let preferred_name = getPreferredName(term);
  return obj.preferred_name = preferred_name.keys ? preferred_name : getMostReferencedByLang(term.identified_by, obj.lang, nameExclude), obj;
}
__name(getULANValue, "getULANValue");
function getTGNValue(term, object = {}) {
  let obj = {};
  obj.subject_of = getPartByType(
    term.subject_of,
    "LinguisticObject",
    object.langs
  ), obj.lang = object.lang == null ? "en" : object.lang, obj.names = getNamesByLang(term), obj.preferred_name = getPreferredName(term);
  let coord = getPartByType(term.identified_by, COORDS, object.langs);
  return coord != null && (obj.coords = JSON.parse(coord)), obj.part_of = term.part_of, obj;
}
__name(getTGNValue, "getTGNValue");
function getAATValue(aatObject, lookupObject) {
  let { number, lang, default_lang_ } = lookupObject;
  if (typeof aatObject != "object" || aatObject == null || Object.keys(aatObject).length < 1)
    return;
  let default_langs = DEFAULT_LANGS;
  if (default_lang_ != null) {
    if (typeof default_lang_ != "string" || default_lang_.length != 2)
      throw "INVALID DEFAULT LANGUAGE";
    default_langs = [], default_langs[0] = default_lang_;
  }
  let cases = [];
  aatObject.part_of != null && (aatObject.part_of == aat$1.DISTANCE_UNIT || aatObject.part_of[0] == aat$1.DISTANCE_UNIT) ? cases = PLURAL : cases = SINGULAR, number != null && number == "plural" && (cases = PLURAL), lookupObject.cases != null && (cases = lookupObject.cases);
  let defaults = [];
  for (var case_ of cases)
    for (var word of aatObject[IDENTIFIED_BY$1]) {
      let c_word = getValue(word, !0), langs = getLanguages(word), classes = getClasses(word);
      if (containsAll(lang, langs, case_, classes))
        return c_word;
      default_langs.forEach((default_lang) => {
        containsAll(default_lang, langs, case_, classes) && defaults.push(c_word);
      });
    }
  let ret;
  return defaults.length > 0 && (ret = defaults[0]), ret;
}
__name(getAATValue, "getAATValue");
function getClasses(obj) {
  let classes = [];
  if (!(obj == null || obj[CLASSIFIED_AS$1] == null))
    return obj[CLASSIFIED_AS$1].forEach((cls) => {
      cls.id == null ? classes.push(cls) : classes.push(cls.id);
    }), classes;
}
__name(getClasses, "getClasses");
function getValue(obj, useLabel = !1) {
  let value = obj.value;
  return value == null && (value = obj.content), value == null && useLabel && (value = obj._label), value == null && (value = obj), value;
}
__name(getValue, "getValue");
function containsAll(lang, langs, case_, classes) {
  return lang == null || langs.includes(lang) == !1 ? !1 : case_.every(function(elem) {
    return classes.indexOf(elem) > -1;
  });
}
__name(containsAll, "containsAll");
function getLanguage(language) {
  if (language != null) {
    if (typeof language == "string")
      return language.split("/").pop();
    if (language[0] && language[0].identified_by)
      return language[0].identified_by[0].id.split("/").pop();
    if (language[0] && language[0].id)
      return language[0].id.split("/").pop();
    if (language.id)
      return language.id.split("/").pop();
  }
}
__name(getLanguage, "getLanguage");
function getLanguages(term) {
  let langs = [];
  return term.language == null ? langs : typeof term.language == "string" ? term.language : (term.language.forEach((lang) => {
    let language = getLanguage(lang);
    lang.identified_by == null ? langs.push(language) : lang.identified_by.forEach((id) => {
      langs.push(id._label);
    });
  }), langs);
}
__name(getLanguages, "getLanguages");
function LCSHLookup(object) {
  return getAllIds(object, "http://id.loc.gov/authorities/names");
}
__name(LCSHLookup, "LCSHLookup");
function findGettyVocabRecursive(object, type) {
  return getAllIds(
    object,
    "http://vocab.getty.edu/" + type.toLowerCase() + "/"
  );
}
__name(findGettyVocabRecursive, "findGettyVocabRecursive");
function findAATRecursive(object) {
  return findGettyVocabRecursive(object, "AAT");
}
__name(findAATRecursive, "findAATRecursive");
function getMostReferencedByLang(submittedResource, lang, excludeClassifications = []) {
  let referenced = {}, filteredResource = submittedResource.filter(
    (_name) => (name) => getClassifiedAs(name, excludeClassifications).length == 0
  );
  return filteredResource = filteredResource.filter((resource) => {
    let language = getLanguage(resource.language);
    if (language == lang || language == null)
      return resource;
  }), referenced[lang] = getMostReferenced(filteredResource), referenced;
}
__name(getMostReferencedByLang, "getMostReferencedByLang");
function convertToTitleCase(str) {
  return str == null || typeof str != "string" ? str : str.replace(/([A-Za-zÀ-ÖØ-öø-ÿ]+[^\s\-]*) */g, function(txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
}
__name(convertToTitleCase, "convertToTitleCase");
function getReferredToByClassification(object, classification) {
  if (!object) return;
  const referredToBy = object[REFERRED_TO_BY$1];
  if (referredToBy)
    return getValueByClassification(referredToBy, classification);
}
__name(getReferredToByClassification, "getReferredToByClassification");
function getManMadeObjectName(manMadeObject) {
  return getEntityName(manMadeObject);
}
__name(getManMadeObjectName, "getManMadeObjectName");
function getActorNames(actors) {
  let names = [];
  return actors.forEach((actor) => {
    var name = getActorName(actor);
    names.push(name);
  }), names;
}
__name(getActorNames, "getActorNames");
function getActorName(actor) {
  return getEntityName(actor);
}
__name(getActorName, "getActorName");
function getEntityName(object) {
  if (object == null || normalizeFieldToArray(object, IDENTIFIED_BY$1).length == 0)
    return;
  let names = _getNameElements(object), name = getValueByClassification(names, aat$1.PREFERRED_TERM);
  if (name == null) {
    let refs = [];
    names.forEach((name_) => {
      name_.content != null && refs.push(name_);
    }), name = getMostReferenced(refs);
  }
  return name;
}
__name(getEntityName, "getEntityName");
function _getNameElements(object) {
  let identified_by = normalizeFieldToArray(object, IDENTIFIED_BY$1), names = [...identified_by, ...getAttributedBy(object, IDENTIFIED_BY$1)];
  return names = names.filter(
    (elem) => elem.type === "Name" && elem.content != null
  ), names.length == 0 && (names = identified_by.filter(
    (elem) => elem.type === "Identifier" && elem.content != null && typeof elem.content == "string"
  )), names;
}
__name(_getNameElements, "_getNameElements");
function getAllNames(object) {
  let names = _getNameElements(object).map((elem) => elem.content);
  return [...new Set(names)];
}
__name(getAllNames, "getAllNames");
function getActiveRange(object) {
  let active_ranges = [], active_results = getClassifiedAs(object.carried_out, aat$1.ACTIVE);
  if (active_results.length != 0)
    return active_results.forEach((active) => {
      let active_range = getDateRange(active);
      active_ranges.push(active_range);
    }), active_ranges;
}
__name(getActiveRange, "getActiveRange");
function _appendProductionSubfield(produced_by, subfield, accumulator) {
  let target = produced_by[subfield];
  target != null && (target.length ? target.forEach((t) => {
    accumulator.push(t);
  }) : accumulator.push(target));
}
__name(_appendProductionSubfield, "_appendProductionSubfield");
function getSubfield(object, source, subField, includePartOf) {
  const array = getProductionData$1(object, source, subField), items = [];
  return array.forEach((item) => {
    normalizeFieldToArray(item, IDENTIFIED_BY$1).forEach((name) => {
      items.push(getValueOrContent(name));
    }), includePartOf && item.part_of && normalizeFieldToArray(item.part_of, IDENTIFIED_BY$1).forEach((name) => {
      items.push(getValueOrContent(name));
    });
  }), items;
}
__name(getSubfield, "getSubfield");
function getProductionData$1(object, source, subfield) {
  let produced_by = object[source], accumulator = [];
  if (produced_by == null)
    return [];
  _appendProductionSubfield(produced_by, subfield, accumulator);
  let parts = produced_by.part;
  return parts != null && parts.forEach((part) => {
    _appendProductionSubfield(part, subfield, accumulator);
  }), accumulator;
}
__name(getProductionData$1, "getProductionData$1");
const MONTHS = {
  "01": "January",
  "02": "February",
  "03": "March",
  "04": "April",
  "05": "May",
  "06": "June",
  "07": "July",
  "08": "August",
  "09": "September",
  10: "October",
  11: "November",
  12: "December"
};
function getDisplayDate(dateRange) {
  let gte = dateRange.gte;
  gte = formatDisplayDate(gte);
  let lte = dateRange.lte;
  return lte == null ? gte : (lte = formatDisplayDate(lte), gte == null ? lte : gte.length === 4 && lte.length === 4 && (parseInt(lte) - parseInt(gte) === 0 || parseInt(lte) - parseInt(gte) === 1) ? gte : gte + " - " + lte);
}
__name(getDisplayDate, "getDisplayDate");
function formatDisplayDate(date) {
  if (date == null)
    return;
  let formattedDate = date.replace("T", " ");
  if (formattedDate.endsWith(" 00:00:00") && (formattedDate = formattedDate.substring(0, 10), formattedDate.endsWith("-01-01") && (formattedDate = formattedDate.substring(0, 4))), formattedDate.endsWith(" 23:59:59") && (formattedDate = formattedDate.substring(0, 10), formattedDate.endsWith("-12-31") && (formattedDate = formattedDate.substring(0, 4))), formattedDate.length === 10) {
    let year = formattedDate.substring(0, 4), month = MONTHS[formattedDate.substring(5, 7)], day = formattedDate.substring(8, 10);
    day[0] === "0" && (day = day[1]), formattedDate = month + " " + day + ", " + year;
  }
  return formattedDate;
}
__name(formatDisplayDate, "formatDisplayDate");
function getDateRange$1(object) {
  let timespan = object.timespan;
  if (timespan == null)
    return;
  let botb = timespan.begin_of_the_begin, eote = timespan.end_of_the_end, range = {};
  const identified = normalizeFieldToArray(timespan, IDENTIFIED_BY$1);
  return identified.length > 0 && identified[0].content != null && (range.content = identified[0].content), botb != null && (botb = botb.replace("T", " ").replace("Z", "")), eote != null && (eote = eote.replace("T", " ").replace("Z", "")), eote == null && botb == null ? range : eote == null ? (range.gte = botb, range) : botb == null ? (range.lte = eote, range) : (range.lte = eote, range.gte = botb, range);
}
__name(getDateRange$1, "getDateRange$1");
function getBirthDateDescription(object, classification) {
  return getDateDescription(object, "born", classification);
}
__name(getBirthDateDescription, "getBirthDateDescription");
function getBirthPlace(object, classification) {
  let birthPlace = getBirthPlaceFromBorn(object);
  return birthPlace || getReferredToByClassification(object, classification);
}
__name(getBirthPlace, "getBirthPlace");
function getBirthPlaceFromBorn(object) {
  const birthEvent = object.born;
  if (!birthEvent) return;
  const tookPlaceAt = normalizeFieldToArray(birthEvent, "took_place_at");
  if (!tookPlaceAt.length) return;
  const identifiedBy = normalizeFieldToArray(tookPlaceAt[0], "identified_by");
  if (identifiedBy.length)
    return identifiedBy[0].content;
}
__name(getBirthPlaceFromBorn, "getBirthPlaceFromBorn");
function getBornRange(object) {
  let born = object.born;
  return born == null ? void 0 : getDateRange$1(born);
}
__name(getBornRange, "getBornRange");
function getDiedRange(object) {
  let died = object.died;
  return died == null ? void 0 : getDateRange$1(died);
}
__name(getDiedRange, "getDiedRange");
function getDateDescription(object, partKey, classification) {
  let part = object[partKey];
  if (part == null)
    return;
  if (part.timespan) {
    let identified = normalizeFieldToArray(part.timespan, IDENTIFIED_BY$1);
    if (identified.length > 0)
      return identified[0].content;
    let descriptionObject2 = getReferredToByClassification(
      part.timespan,
      classification
    );
    if (descriptionObject2 != null)
      return descriptionObject2;
  }
  let descriptionObject = getReferredToByClassification(part, classification);
  if (descriptionObject != null)
    return descriptionObject;
}
__name(getDateDescription, "getDateDescription");
function getDeathDateDescription(object, classification) {
  return getDateDescription(object, "died", classification);
}
__name(getDeathDateDescription, "getDeathDateDescription");
function getDeathPlace(object, classification) {
  let deathPlace = getDeathPlaceFromDied(object);
  return deathPlace || getReferredToByClassification(object, classification);
}
__name(getDeathPlace, "getDeathPlace");
function getDeathPlaceFromDied(object) {
  const deathEvent = object.died;
  if (!deathEvent) return;
  const tookPlaceAt = normalizeFieldToArray(deathEvent, TOOK_PLACE_AT);
  if (!tookPlaceAt.length) return;
  const identifiedBy = normalizeFieldToArray(tookPlaceAt[0], IDENTIFIED_BY$1);
  if (identifiedBy.length)
    return identifiedBy[0].content;
}
__name(getDeathPlaceFromDied, "getDeathPlaceFromDied");
function getDescription$2(object, format) {
  return getContentWithFormat(
    object,
    REFERRED_TO_BY$1,
    aat$1.BIOGRAPHIES,
    format
  )[0];
}
__name(getDescription$2, "getDescription$2");
function getNationality(object, aatQualifiers, lang_) {
  let nationalities = [];
  for (var c of getClassifiedAs(object.classified_as, aat$1.NATIONALITY))
    nationalities.push(
      findAndGetAATValue({
        id: c.id,
        qualifiers: aatQualifiers,
        lang: lang_
      })
    );
  return nationalities;
}
__name(getNationality, "getNationality");
function getRole(person, aatQualifiers, lang_) {
  let roles = [];
  const roleRefs = getRoleReferences(person);
  return roleRefs.length && roleRefs.forEach((ref) => {
    let val = findAndGetAATValue({
      id: ref.id,
      qualifiers: aatQualifiers,
      lang: lang_
    });
    roles.push(convertToTitleCase(val));
  }), roles;
}
__name(getRole, "getRole");
function getRoleReferences(object) {
  const classifications = object.classified_as;
  return classifications ? getClassifiedAs(classifications, aat$1.ROLES) : [];
}
__name(getRoleReferences, "getRoleReferences");
function getUlanLink(object) {
  let exactMatch = normalizeFieldToArray(object, "exact_match"), url;
  for (let match of exactMatch)
    match != null && match.id.indexOf("vocab.getty.edu/ulan") > -1 && (url = match.id);
  return url;
}
__name(getUlanLink, "getUlanLink");
function getName$1(object) {
  return getManMadeObjectName(object);
}
__name(getName$1, "getName$1");
function getArtistNames(actors) {
  return getActorNames(actors);
}
__name(getArtistNames, "getArtistNames");
function getArtistFromObject(object) {
  return object == null ? [] : getProductionData$1(object, PRODUCED_BY$1, CARRIED_OUT_BY$1);
}
__name(getArtistFromObject, "getArtistFromObject");
function getCreationDate$1(object, includePartOf) {
  return getSubfield(object, PRODUCED_BY$1, "timespan", includePartOf);
}
__name(getCreationDate$1, "getCreationDate$1");
function getCreationDateTimespan$1(object) {
  return getProductionData$1(object, PRODUCED_BY$1, "timespan");
}
__name(getCreationDateTimespan$1, "getCreationDateTimespan$1");
function getCreationPlace(object) {
  let places = [];
  const referredToBy = normalizeFieldToArray(object, REFERRED_TO_BY$1);
  return referredToBy.length > 0 && (places = getValuesByClassification(referredToBy, aat$1.PLACE_CREATED)), places == null && (places = []), places = places.concat(
    getSubfield(object, PRODUCED_BY$1, TOOK_PLACE_AT)
  ), places;
}
__name(getCreationPlace, "getCreationPlace");
function getProductionData(object, subfield, aatQualifiers, lang_) {
  let targets = getProductionData$1(object, PRODUCED_BY$1, subfield), accumulator = [];
  return targets.forEach((item) => {
    accumulator.push(
      findAndGetAATValue({
        id: item.id,
        qualifiers: aatQualifiers,
        lang: lang_
      })
    );
  }), accumulator;
}
__name(getProductionData, "getProductionData");
function getTechnique(object, aatQualifiers, lang_) {
  return getProductionData(object, "technique", aatQualifiers, lang_);
}
__name(getTechnique, "getTechnique");
function getMedium(object, aatQualifiers, lang_) {
  return getProductionData(object, "made_of", aatQualifiers, lang_);
}
__name(getMedium, "getMedium");
function getImageUrls(object) {
  const representations = getClassifiedAs(
    normalizeFieldToArray(object, REPRESENTATION$1),
    aat$1.DIGITAL_IMAGE
  );
  return representations == null || representations.length == 0 ? void 0 : representations.map((representation) => representation.id);
}
__name(getImageUrls, "getImageUrls");
function getThumbnailUrl(object, width = "300") {
  const images = getImageUrls(object);
  if (images == null)
    return;
  let thumb = images.filter((image) => image.includes("thumbnail"));
  return thumb == null || thumb.length == 0 ? (thumb = images[0].replace(
    "full/0/default.jpg",
    "!" + width + "," + width + "/0/default.jpg"
  ), thumb) : thumb[0];
}
__name(getThumbnailUrl, "getThumbnailUrl");
function getClassification(object, aatQualifiers) {
  let references = normalizeFieldToArray(object, CLASSIFIED_AS$1);
  return references = getClassifiedAs(references, aat$1.CLASSIFICATION), references.length < 1 ? void 0 : findAndGetAATValue({
    id: references[0].id,
    qualifiers: aatQualifiers
  });
}
__name(getClassification, "getClassification");
function getCulture(object) {
  return getValuesByClassification(object.referred_to_by, aat$1.CULTURE);
}
__name(getCulture, "getCulture");
function getObjectNumber(object) {
  let id_nums = getClassifiedAs(
    object.identified_by,
    aat$1.IDENTIFICATION_NUMBER
  ), preferred = getValueByClassification(id_nums, aat$1.PREFERRED_TERM);
  return preferred || getValueOrContent(id_nums[0]);
}
__name(getObjectNumber, "getObjectNumber");
function getAccessionNumber(object) {
  return getValueByClassification(object.identified_by, aat$1.ACCESSION_NUMBER);
}
__name(getAccessionNumber, "getAccessionNumber");
function getManuscriptNumber(object, classification) {
  return getValueByClassification(object.identified_by, classification);
}
__name(getManuscriptNumber, "getManuscriptNumber");
function getDimensionStatement(object) {
  return _getDisplayValues(
    object,
    REFERRED_TO_BY$1,
    aat$1.DIMENSIONS_DESCRIPTION
  );
}
__name(getDimensionStatement, "getDimensionStatement");
function getMaterialStatement(object) {
  return _getDisplayValue(
    object,
    REFERRED_TO_BY$1,
    aat$1.MATERIALS_DESCRIPTION
  );
}
__name(getMaterialStatement, "getMaterialStatement");
function getSignatures(object) {
  return _getDisplayValues(
    object,
    CARRIES,
    aat$1.SIGNATURES_DESCRIPTION
  );
}
__name(getSignatures, "getSignatures");
function getMarks(object) {
  return _getDisplayValues(object, CARRIES, aat$1.MARKS);
}
__name(getMarks, "getMarks");
function getInscriptions(object) {
  return _getDisplayValues(object, CARRIES, aat$1.INSCRIPTIONS);
}
__name(getInscriptions, "getInscriptions");
function getWatermarks(object) {
  return _getDisplayValues(object, CARRIES, aat$1.WATERMARKS);
}
__name(getWatermarks, "getWatermarks");
function getAlternateTitles(object) {
  return getTitlesWithQualifier(object, aat$1.ALTERNATE_TITLE);
}
__name(getAlternateTitles, "getAlternateTitles");
function getTitlesWithQualifier(object, qualifier) {
  if (normalizeFieldToArray(object, IDENTIFIED_BY$1).length == 0)
    return;
  const titles = _getNameElements(object), alternates = getClassifiedAs(titles, qualifier);
  if (alternates.length == 0)
    return;
  let altTitles = [];
  return alternates.forEach((alt) => {
    altTitles.includes(alt.content) == !1 && altTitles.push(alt.content);
  }), altTitles;
}
__name(getTitlesWithQualifier, "getTitlesWithQualifier");
function getGroupTitles(object, classification) {
  return getTitlesWithQualifier(object, classification);
}
__name(getGroupTitles, "getGroupTitles");
function getDescription$1(object, format = void 0) {
  return getContentWithFormat(
    object,
    REFERRED_TO_BY$1,
    aat$1.DESCRIPTION,
    format
  )[0];
}
__name(getDescription$1, "getDescription$1");
function _getDisplayValue(object, arrayName, classification) {
  const array = normalizeFieldToArray(object, arrayName);
  return array.length == 0 ? void 0 : getValueByClassification(array, classification);
}
__name(_getDisplayValue, "_getDisplayValue");
function _getDisplayValues(object, arrayName, classification) {
  const array = normalizeFieldToArray(object, arrayName);
  return array.length == 0 ? void 0 : getValuesByClassification(array, classification);
}
__name(_getDisplayValues, "_getDisplayValues");
function getObjectType(object) {
  const referredToBy = normalizeFieldToArray(object, REFERRED_TO_BY$1);
  if (referredToBy.length)
    return getValueByClassification(referredToBy, aat$1.OBJECT_TYPE);
}
__name(getObjectType, "getObjectType");
function getCopyrightStatement(object, COPYRIGHT2 = aat$1.COPYRIGHT) {
  return getValueByClassification(
    normalizeFieldToArray(object, REFERRED_TO_BY$1),
    COPYRIGHT2
  );
}
__name(getCopyrightStatement, "getCopyrightStatement");
function getRightsStatement(object, RIGHTS_STATEMENT2 = aat$1.RIGHTS_STATEMENT) {
  return getValueByClassification(
    normalizeFieldToArray(object, REFERRED_TO_BY$1),
    RIGHTS_STATEMENT2
  );
}
__name(getRightsStatement, "getRightsStatement");
function getRightsStatementId$1(object, RIGHTS_STATEMENT2 = aat$1.RIGHTS_STATEMENT) {
  const rights = getClassifiedAs(
    normalizeFieldToArray(object, REFERRED_TO_BY$1),
    RIGHTS_STATEMENT2
  );
  if (rights.length)
    return rights[0].id;
}
__name(getRightsStatementId$1, "getRightsStatementId$1");
function getPlaceDepicted(obj, PLACE_DEPICTED) {
  const shows = normalizeFieldToArray(obj, "shows");
  if (shows.length == 0)
    return [];
  let toReturn = [];
  return shows.forEach(function(show) {
    let ref = normalizeFieldToArray(show, REFERRED_TO_BY$1), parts = getValuesByClassification(ref, PLACE_DEPICTED);
    toReturn = toReturn.concat(parts);
  }), toReturn;
}
__name(getPlaceDepicted, "getPlaceDepicted");
function getPlaceFound(obj, PLACE_FOUND) {
  return getValuesByClassification(
    normalizeFieldToArray(obj, REFERRED_TO_BY$1),
    PLACE_FOUND
  );
}
__name(getPlaceFound, "getPlaceFound");
function getCreationDate(object) {
  return getSubfield(object, CREATED_BY, TIMESPAN$1);
}
__name(getCreationDate, "getCreationDate");
function getCreationDateTimespan(object) {
  return getProductionData$1(object, CREATED_BY, TIMESPAN$1);
}
__name(getCreationDateTimespan, "getCreationDateTimespan");
const OPEN_CONTENT_LICENSES = [
  "rightsstatements.org/vocab/NoC-NC/1.0/",
  "rightsstatements.org/vocab/NoC-US/1.0/",
  "creativecommons.org/publicdomain/zero/1.0/"
], OPEN_CONTENT = "open", CLOSED_CONTENT = "closed", MIXED_CONTENT = "mixed";
function summarizeLicenses(licenses, openContentLicenses = OPEN_CONTENT_LICENSES) {
  let status;
  for (let license of licenses)
    if (license != null) {
      if (license = license.split("://")[1], openContentLicenses.includes(license) && status != OPEN_CONTENT) {
        status == null ? status = OPEN_CONTENT : status = MIXED_CONTENT;
        continue;
      }
      if (openContentLicenses.includes(license) == !1 && status != CLOSED_CONTENT)
        if (status == null) {
          status = CLOSED_CONTENT;
          continue;
        } else
          status = MIXED_CONTENT;
    }
  return status;
}
__name(summarizeLicenses, "summarizeLicenses");
const IIIF_API = "http://iiif.io/api/presentation", SUBJECT_OF = "subject_of", CUSTOM_MANIFEST = "https://data.getty.edu/local/thesaurus/iiif-manifest-custom", IIIF_V2 = 'application/ld+json;profile="http://iiif.io/api/presentation/2/context.json"', IIIF_V3 = 'application/ld+json;profile="http://iiif.io/api/presentation/3/context.json"';
function getManifestInformation(manifest, isIIIFV3 = !1, locale = "en") {
  let details = {}, licenseKey = isIIIFV3 ? "rights" : "license";
  return manifest[licenseKey] && (details.license = manifest[licenseKey]), isIIIFV3 ? manifest.requiredStatement && (details.attribution = manifest.requiredStatement.value[locale]) : manifest.attribution && (details.attribution = manifest.attribution), details;
}
__name(getManifestInformation, "getManifestInformation");
function getManifestUrls(object, options = {}) {
  return getManifestObjects(object, options).map((manifest) => manifest.url);
}
__name(getManifestUrls, "getManifestUrls");
function getManifestObjects(object, options = {}) {
  return "excludeCustom" in options || (options.excludeCustom = CUSTOM_MANIFEST), normalizeFieldToArray(object, SUBJECT_OF).filter((obj) => {
    if (!(!obj.conforms_to || obj.conforms_to[0].id != IIIF_API) && !(options.format && obj.format != options.format) && !(options.excludeCustom && obj.classified_as && obj.classified_as.filter(
      (cls) => cls.id == options.excludeCustom
    ).length > 0))
      return obj;
  }).map((manifest) => ({
    url: manifest.id,
    title: getName$1(manifest),
    format: manifest.format,
    custom: !!getClassifiedAs(manifest, CUSTOM_MANIFEST).length
  }));
}
__name(getManifestObjects, "getManifestObjects");
function getManifestThumb(manifest, size = 300, isIIIFV3 = !1) {
  var _a, _b, _c, _d, _e;
  let idKey = isIIIFV3 ? "id" : "@id";
  if (isIIIFV3) {
    if (manifest.thumbnail && ((_a = manifest.thumbnail[0]) != null && _a.service) && ((_b = manifest.thumbnail[0].service[0]) == null ? void 0 : _b.type) == "ImageService3")
      return `${manifest.thumbnail[0].service[0].id}/full/!${size},${size}/0/default.jpg`;
    if (manifest.thumbnail && ((_c = manifest.thumbnail[0]) != null && _c.id))
      return (_d = manifest.thumbnail[0]) == null ? void 0 : _d.id;
    if (manifest.thumbnail && typeof manifest.thumbnail == "string")
      return manifest.thumbnail;
  } else {
    if ((_e = manifest.thumbnail) != null && _e.service && manifest.thumbnail.service["@context"] == "http://iiif.io/api/image/2/context.json")
      return `${manifest.thumbnail.service[idKey]}/full/!${size},${size}/0/default.jpg`;
    if (manifest.thumbnail && manifest.thumbnail[idKey])
      return manifest.thumbnail[idKey];
    if (manifest.thumbnail && typeof manifest.thumbnail == "string")
      return manifest.thumbnail;
  }
  return getIIIFImageWithSize(manifest, 300, 0, 0, 0, isIIIFV3);
}
__name(getManifestThumb, "getManifestThumb");
function getIIIFImageWithSize(manifest, size = 300, sequenceNumber = 0, canvasNumber = 0, imageNumber = 0, isIIIFV3 = !1) {
  var _a, _b, _c;
  if (isIIIFV3) {
    if (manifest.items[sequenceNumber].items && manifest.items[sequenceNumber].items[canvasNumber].items && ((_b = (_a = manifest.items[sequenceNumber].items[canvasNumber].items[0]) == null ? void 0 : _a.body) != null && _b.service))
      return `${manifest.items[sequenceNumber].items[canvasNumber].items[0].body.service[imageNumber].id}/full/!${size},${size}/0/default.jpg`;
  } else if (manifest.sequences && manifest.sequences[sequenceNumber].canvases && manifest.sequences[sequenceNumber].canvases[canvasNumber].images && ((_c = manifest.sequences[sequenceNumber].canvases[canvasNumber].images[imageNumber].resource) != null && _c.service))
    return `${manifest.sequences[sequenceNumber].canvases[canvasNumber].images[imageNumber].resource.service["@id"]}/full/!${size},${size}/0/default.jpg`;
  return null;
}
__name(getIIIFImageWithSize, "getIIIFImageWithSize");
function getCanvasInfo(manifest, canvasNumber) {
  let sequence = manifest.sequences[0], canvas = sequence.canvases[canvasNumber];
  if (canvas == null)
    return;
  let ret = {
    label: canvas.label,
    sequence: 0,
    canvasNumber
  };
  if (canvas.images && canvas.images[0] != null) {
    let image = canvas.images[0];
    ret.url = image.resource.service["@id"], updateAttributionOrLicenseIfUnset(ret, image);
  }
  return updateAttributionOrLicenseIfUnset(ret, canvas), updateAttributionOrLicenseIfUnset(ret, sequence), updateAttributionOrLicenseIfUnset(ret, manifest), ret;
}
__name(getCanvasInfo, "getCanvasInfo");
function updateAttributionOrLicenseIfUnset(item, partToCheck) {
  item.license == null && partToCheck.license != null && (item.license = partToCheck.license), item.attribution == null && partToCheck.attribution != null && (item.attribution = partToCheck.attribution);
}
__name(updateAttributionOrLicenseIfUnset, "updateAttributionOrLicenseIfUnset");
function getObjectRightsStatus(manifest, openContentLicenses) {
  let licenses = /* @__PURE__ */ new Set();
  licenses.add(manifest.license);
  for (let i = 0; i < manifest.sequences[0].canvases.length; i++) {
    let info = getCanvasInfo(manifest, i);
    licenses.add(info.license);
  }
  return summarizeLicenses(licenses, openContentLicenses);
}
__name(getObjectRightsStatus, "getObjectRightsStatus");
function extractImageUuid(imageUrl, _BASE = "/image/") {
  let BASE = _BASE;
  if (BASE.endsWith("/") == !1 && (BASE += "/"), imageUrl == null || imageUrl.indexOf(BASE) == -1)
    return;
  let thumbId = imageUrl.substring(imageUrl.indexOf(BASE) + BASE.length);
  return thumbId.indexOf("/") > -1 && (thumbId = thumbId.substring(0, thumbId.indexOf("/"))), thumbId;
}
__name(extractImageUuid, "extractImageUuid");
function getAIN(object) {
  const identifiedBy = normalizeFieldToArray(object, IDENTIFIED_BY$1), ain = getValuesByClassification(identifiedBy, aat$1.AIN);
  return ain || [];
}
__name(getAIN, "getAIN");
function getLocationMessage(placeObject) {
  if (placeObject == null)
    return;
  let idArray = normalizeFieldToArray(placeObject, IDENTIFIED_BY$1), preferred = getClassifiedAs(idArray, aat$1.PLACE_PREFERRED_TERM);
  if (!(preferred.length < 1))
    return preferred[0].content;
}
__name(getLocationMessage, "getLocationMessage");
function getName(object) {
  if (!object || !normalizeFieldToArray(object, IDENTIFIED_BY$1).length)
    return;
  let names = _getNameElements(object), name = getValueByClassification(names, aat$1.PREFERRED_TERM), address = getStreetAddress(object);
  if (name == null && address.length > 0 && (name = address[0]), name == null) {
    let refs = [];
    names.forEach((name_) => {
      name_.content != null && refs.push(name_);
    }), name = getMostReferenced(refs);
  }
  return name;
}
__name(getName, "getName");
function getParentID(object) {
  const partOf = normalizeFieldToArray(object, PART_OF);
  if (!(partOf.length < 1))
    return partOf[0].id;
}
__name(getParentID, "getParentID");
function getPlaceHierarchy(object) {
  let childToParent = {}, partOf = normalizeFieldToArray(object, PART_OF), currentObj = object;
  for (; partOf.length > 0; )
    childToParent[currentObj.id] = getParentID(currentObj), currentObj = partOf[0], partOf = normalizeFieldToArray(currentObj, PART_OF);
  return Object.values(childToParent);
}
__name(getPlaceHierarchy, "getPlaceHierarchy");
function getStreetAddress(object) {
  const identifiedBy = normalizeFieldToArray(object, IDENTIFIED_BY$1), address = getValuesByClassification(identifiedBy, aat$1.STREET_ADDRESSES);
  return address || [];
}
__name(getStreetAddress, "getStreetAddress");
function getAltText(visualItem, altQualifier = "https://data.getty.edu/local/thesaurus/alt-text") {
  if (visualItem != null)
    return getValueByClassification(visualItem.subject_of, altQualifier);
}
__name(getAltText, "getAltText");
function getDescription(visualItem) {
  if (visualItem != null)
    return getValueByClassification(visualItem.subject_of, aat$1.DESCRIPTIVE_NOTE);
}
__name(getDescription, "getDescription");
function getIIIFImageId(visualItem, imageServiceQualifier = "https://data.getty.edu/local/thesaurus/iiif-image") {
  return getShownById(visualItem, imageServiceQualifier);
}
__name(getIIIFImageId, "getIIIFImageId");
function getShownById(visualItem, qualifier) {
  let toReturn;
  return normalizeFieldToArray(visualItem, DIGITALLY_SHOWN_BY).forEach((item) => {
    let ids = getClassifiedAs(item.access_point, qualifier);
    ids.length > 0 && toReturn == null && ids.forEach((obj) => {
      toReturn = obj.id;
    });
  }), toReturn;
}
__name(getShownById, "getShownById");
function getClearanceLevel(visualItem, levelQualifier = "https://data.getty.edu/local/thesaurus/clearance-level") {
  return visualItem == null ? [] : getClassifiedAsWithClassification(
    visualItem.subject_to,
    levelQualifier
  );
}
__name(getClearanceLevel, "getClearanceLevel");
function getRightsStatementId(visualItem, statementQualifier = "https://data.getty.edu/local/thesaurus/rightsstatement-org-statement") {
  if (visualItem == null)
    return;
  let statements = getClassifiedAsWithClassification(
    visualItem.subject_to,
    statementQualifier
  );
  if (statements.length == 1)
    return statements[0].id;
}
__name(getRightsStatementId, "getRightsStatementId");
export {
  CLOSED_CONTENT,
  CUSTOM_MANIFEST,
  IIIF_V2,
  IIIF_V3,
  LCSHLookup,
  MIXED_CONTENT,
  OPEN_CONTENT,
  OPEN_CONTENT_LICENSES,
  convertToTitleCase,
  extractImageUuid,
  findAATRecursive,
  findAndGetAATValue,
  findAndGetTGNValue,
  findAndGetULANValue,
  findGettyVocabRecursive,
  formatDisplayDate,
  getAIN,
  getAccessionNumber,
  getActiveRange,
  getDescription$2 as getActorDescription,
  getAllIds,
  getAllNames,
  getAltText,
  getAlternateTitles,
  getArtistFromObject,
  getArtistNames,
  getBirthDateDescription,
  getBirthPlace,
  getBornRange,
  getCanvasInfo,
  getClassification,
  getClearanceLevel,
  getContentWithFormat,
  getCopyrightStatement,
  getCreationDate$1 as getCreationDate,
  getCreationDateTimespan$1 as getCreationDateTimespan,
  getCreationPlace,
  getCulture,
  getDateRange$1 as getDateRange,
  getDeathDateDescription,
  getDeathPlace,
  getDescription,
  getDiedRange,
  getDimensionStatement,
  getDisplayDate,
  getEntityName,
  getGroupTitles,
  getIIIFImageId,
  getIIIFImageWithSize,
  getImageUrls,
  getCreationDate as getInformationObjectCreationDate,
  getCreationDateTimespan as getInformationObjectCreationDateTimespan,
  getInscriptions,
  getLocationMessage,
  getManifestInformation,
  getManifestObjects,
  getManifestThumb,
  getManifestUrls,
  getManuscriptNumber,
  getMarks,
  getMaterialStatement,
  getMedium,
  getMostReferenced,
  getMostReferencedByLang,
  getEntityName as getName,
  getNationality,
  getDescription$1 as getObjectDescription,
  getObjectNumber,
  getObjectRightsStatus,
  getObjectType,
  getParentID,
  getPlaceDepicted,
  getPlaceFound,
  getPlaceHierarchy,
  getName as getPlaceName,
  getProductionData$1 as getProductionData,
  getReferredToByClassification,
  getRightsStatement,
  getRightsStatementId$1 as getRightsStatementId,
  getRole,
  getRoleReferences,
  getSignatures,
  getStreetAddress,
  getSubfield,
  getTechnique,
  getThumbnailUrl,
  getTitlesWithQualifier,
  getULANValue,
  getUlanLink,
  getRightsStatementId as getVisualItemsRightsStatementId,
  getWatermarks,
  summarizeLicenses
};
